/* Cart drawer analytics.
 *
 * Each event goes to three places:
 *  - Shopify Customer Events (Shopify.analytics.publish) — a custom pixel in
 *    Shopify admin → Settings → Customer events subscribes and forwards to
 *    GA4 / GTM-in-pixel / Meta / TikTok
 *  - window.dataLayer — for GTM loaded on the page
 *  - Microsoft Clarity — custom events + session tags
 * The pixel code and setup steps live in docs/cart-analytics.md.
 *
 * Every event carries the current cart context (value, item count, B1G2F
 * progress, customer status) plus the event's own fields.
 *
 * QA: run localStorage.cdTrackDebug = '1' in the console to log every event.
 */
(function (window, document) {
  if (window.cdTrack) return;

  var queue = [];
  var timer = null;
  var tries = 0;
  var seenViews = {};
  var observer = null;
  var observed = typeof WeakSet === 'function' ? new WeakSet() : null;

  function debugOn() {
    try {
      return window.localStorage && window.localStorage.getItem('cdTrackDebug') === '1';
    } catch (err) {
      return false;
    }
  }

  function canPublish() {
    return !!(window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function');
  }

  function publish(name, data) {
    try {
      window.Shopify.analytics.publish(name, data);
    } catch (err) {}
  }

  function flush() {
    while (queue.length && canPublish()) {
      var ev = queue.shift();
      publish(ev[0], ev[1]);
    }
  }

  /* The web pixels manager loads async; hold early events for up to ~10s. */
  function schedule() {
    if (timer) return;
    timer = window.setInterval(function () {
      tries += 1;
      flush();
      if (!queue.length || tries > 40) {
        window.clearInterval(timer);
        timer = null;
        tries = 0;
        queue.length = 0;
      }
    }, 250);
  }

  function assign(target, src) {
    if (!src) return target;
    for (var k in src) {
      if (Object.prototype.hasOwnProperty.call(src, k) && src[k] !== undefined) target[k] = src[k];
    }
    return target;
  }

  function context() {
    var ctx = {};
    var meta = window.cdTrackMeta || {};
    ctx.currency = meta.currency || '';
    ctx.customer_status = meta.customerStatus || 'guest';
    var cart = null;
    try {
      cart = window.CDFilled && window.CDFilled.analyticsContext && window.CDFilled.analyticsContext();
    } catch (err) {}
    if (cart) {
      assign(ctx, cart);
    } else {
      assign(ctx, {
        cart_value: 0,
        cart_item_count: 0,
        b1g2f_pairs: 0,
        b1g2f_step: 0,
        b1g2f_sets_complete: 0,
        b1g2f_status: 'none'
      });
    }
    ctx.cart_state = ctx.cart_item_count > 0 ? 'filled' : 'empty';
    return ctx;
  }

  /* GTM on the page: every event is pushed to window.dataLayer as
     { event: '<name>', cart_event: {…} }. cart_event is cleared first so a
     field from an earlier event never leaks into the next one. Harmless when
     GTM isn't on the page (nothing reads the array). */
  function toDataLayer(name, payload) {
    try {
      var dl = (window.dataLayer = window.dataLayer || []);
      dl.push({ cart_event: null });
      dl.push({ event: name, cart_event: payload });
    } catch (err) {}
  }

  /* Microsoft Clarity (loaded after analytics consent by
     snippets/consent-gated-scripts.liquid, which stubs window.clarity so these
     calls queue until then): a custom event per
     cart event, a few session tags to filter recordings by, and a priority
     recording for sessions that hit a cart error or click Checkout. */
  var CLARITY_TAGS = ['b1g2f_status', 'customer_status', 'upsell_type'];
  function toClarity(name, payload) {
    var clarity = window.clarity;
    if (typeof clarity !== 'function') return;
    try {
      clarity('event', name);
      CLARITY_TAGS.forEach(function (key) {
        if (payload[key] != null && payload[key] !== '') clarity('set', 'cart_' + key, String(payload[key]));
      });
      if (name === 'cart_error' || name === 'cart_checkout_clicked') clarity('upgrade', name);
    } catch (err) {}
  }

  function cdTrack(name, data) {
    var payload = assign(context(), data);
    if (debugOn()) console.info('[cdTrack]', name, payload);
    toDataLayer(name, payload);
    toClarity(name, payload);
    if (canPublish()) {
      flush();
      publish(name, payload);
    } else {
      queue.push([name, payload]);
      schedule();
    }
  }

  function drawerOpen() {
    var el = document.getElementById('shopify-section-cart-drawer');
    return !!(el && el.classList.contains('slided'));
  }

  /* cart_upsell_viewed: any [data-cd-upsell] block at least half on screen
     while the drawer is open, once per drawer open per block + tab. */
  function onIntersect(entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting || !drawerOpen()) return;
      var el = entry.target;
      var type = el.getAttribute('data-cd-upsell') || '';
      var tab = el.getAttribute('data-cd-upsell-tab') || '';
      var key = type + '|' + tab;
      if (seenViews[key]) return;
      seenViews[key] = true;
      cdTrack('cart_upsell_viewed', {
        upsell_type: type,
        upsell_tab: tab,
        upsell_item_count: el.querySelectorAll('[data-cd-atc], [data-cd-empty-atc], [data-cd-mystery-add]').length
      });
    });
  }

  cdTrack.observeUpsells = function (root) {
    if (!root || typeof IntersectionObserver !== 'function') return;
    if (!observer) observer = new IntersectionObserver(onIntersect, { threshold: 0.5 });
    root.querySelectorAll('[data-cd-upsell]').forEach(function (el) {
      if (observed) {
        if (observed.has(el)) return;
        observed.add(el);
      }
      observer.observe(el);
    });
  };

  /* A fresh drawer open counts as a fresh view of every upsell. */
  cdTrack.resetViews = function () {
    seenViews = {};
    if (!observer) return;
    var root = document.getElementById('shopify-section-cart-drawer');
    observer.disconnect();
    observed = typeof WeakSet === 'function' ? new WeakSet() : null;
    if (root) cdTrack.observeUpsells(root);
  };

  /* Product fields for an add button: data-cd-* on the button, and its
     1-based position among the buttons of its upsell block. */
  cdTrack.productFields = function (btn) {
    if (!btn) return {};
    var block = btn.closest('[data-cd-upsell]');
    var fields = {
      upsell_type: block ? block.getAttribute('data-cd-upsell') || '' : '',
      upsell_tab: block ? block.getAttribute('data-cd-upsell-tab') || '' : '',
      product_handle: btn.getAttribute('data-handle') || '',
      variant_id: btn.getAttribute('data-variant-id') || '',
      product_title: btn.getAttribute('data-cd-title') || '',
      product_type: btn.getAttribute('data-cd-type') || '',
      price: Number(btn.getAttribute('data-cd-price')) || 0
    };
    if (block) {
      var btns = block.querySelectorAll('[data-cd-atc], [data-cd-empty-atc], [data-cd-mystery-add]');
      for (var i = 0; i < btns.length; i++) {
        if (btns[i] === btn) {
          fields.position = i + 1;
          break;
        }
      }
    }
    return fields;
  };

  window.cdTrack = cdTrack;
})(window, document);
